import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ontruck/orc';
import LoadSpinner from 'components/LoadSpinner';

const PriceButton = ({ className, onClick, disabled, submitting, text }) => (
  <div className={`${submitting ? className : ''} form-button-container`}>
    <Button
      dataE2E="so-continue"
      data-testid="price-button"
      onClick={onClick}
      disabled={disabled}
      text={submitting ? <LoadSpinner skin="inButton" /> : text}
      size="XL"
      icon={submitting ? null : 'continue'}
    />
  </div>
);

PriceButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

PriceButton.defaultProps = {
  className: '',
  disabled: false,
  submitting: false,
};

export default PriceButton;
